import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {OkCancelDialog} from '../../../../../../../../src/components/common/dialogs/okCancelDialog';
import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../../../../shared/ui/src/components/buttons/buttonConstants';

/*
 * Props.
 */

interface CrmSyncsUnsavedChangesDialogProps {
  onClose: Handler;
  onSave: Handler;
}

/*
 * Component.
 */

export const CrmSyncsUnsavedChangesDialog: FC<CrmSyncsUnsavedChangesDialogProps> = (props) => {
  const {onClose, onSave} = props;
  return (
    <OkCancelDialog
      title={<Trans id="crm-syncs-unsaved-changes-title">Unsaved changes</Trans>}
      okButtonLabel={<Trans id="crm-syncs-unsaved-changes-ok-button">Save changes</Trans>}
      okButtonVariant={ButtonVariantsEnum.PRIMARY}
      onRequestClose={onClose}
      onOkClick={() => {
        onSave();
        onClose();
      }}
    >
      <Trans id="crm-syncs-unsaved-changes-dialog-message">
        You have unsaved changes. Do you want to save changes?
      </Trans>
    </OkCancelDialog>
  );
};
